import styled from 'styled-components';

export const FlexContainer = styled.div<FlexContainerProps> `
  display: flex;
  flex-direction: ${({ direction }) => direction || 'row'};
  align-items: ${({ alignItems }) => alignItems || 'center'};
  justify-content: ${({ justifyContent }) => justifyContent || 'flex-start'};
  width: ${({ width }) => width || '100%'};
`;

type FlexContainerProps = {
  direction?: 'row' | 'row-reverse' | 'column' | 'column-reverse';
  alignItems?: 'center' | 'flex-end' | 'flex-start';
  justifyContent?: 'space-between' | 'center';
  width?: string;
  mobilePadding?: string;
};
